import { z } from 'zod';
/** `PUT /automations/:key` — the switch and any options the automation declares. */
export const updateAutomationSchema = z.object({
    enabled: z.boolean().optional(),
    options: z.record(z.string(), z.boolean()).optional(),
    /** A scheduled automation's days; the service holds it to that automation's bounds. */
    days: z.number().int().min(0).max(365).optional(),
});
//# sourceMappingURL=automations.js.map